import {
  AlertDialog, AlertDialogAction, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ShieldCheck } from "@phosphor-icons/react";
import { fmtMoney, fmtDate } from "@/lib/api";

export default function NCSuccessDialog({ ncSuccess, onClose }) {
  return (
    <AlertDialog open={!!ncSuccess} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent className="max-w-lg" data-testid="nc-success-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <ShieldCheck size={18} weight="fill" className="text-emerald-700" />
            Nota de Crédito emitida
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-[13px]">
              <p>
                Se emitió correctamente la NC anulando{" "}
                <span className="font-mono font-semibold">
                  {ncSuccess?.factura_original?.tipo_comprobante} {ncSuccess?.factura_original?.numero}
                </span>.
              </p>
              <div className="border border-emerald-200 rounded-sm bg-emerald-50/60 p-3 space-y-1 text-[12px] font-mono">
                <div><span className="text-[#666]">Nº NC:</span> <span className="font-semibold">{ncSuccess?.nota_credito?.numero}</span></div>
                <div><span className="text-[#666]">Tipo:</span> {ncSuccess?.nota_credito?.tipo_comprobante}</div>
                {ncSuccess?.nota_credito?.cae && (
                  <>
                    <div><span className="text-[#666]">CAE:</span> {ncSuccess.nota_credito.cae}</div>
                    <div><span className="text-[#666]">Vto. CAE:</span> {fmtDate(ncSuccess.nota_credito.cae_vencimiento)}</div>
                  </>
                )}
                <div><span className="text-[#666]">Total:</span> {fmtMoney(ncSuccess?.nota_credito?.total || 0)}</div>
              </div>
              <p className="text-[11px] text-[#666]">
                Ambos comprobantes (factura original + NC) quedan registrados. La factura original figura como <span className="font-mono">ANULADA</span>.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            data-testid="nc-success-close"
            onClick={onClose}
            className="rounded-sm bg-emerald-700 hover:bg-emerald-800"
          >
            Cerrar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
